module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp12_3016.7323e217.png";